import { getGlobalHeadersAsObject } from "../global-headers";
import type { DRFListResponseWrapper } from "../types";

export type PersonSkill = {
	name: string;
	skill_name: number;
	endorsements: number;
};

export const getPersonSkillsById = (
	personId: number,
	highlight?: number
): Promise<DRFListResponseWrapper<PersonSkill[]>> => {
	if (!personId || typeof personId !== "number") {
		throw new Error(
			`getPersonSkillsById called with invalid argument id '${personId}'. Expected number`
		);
	}

	const url = new URL(`/api/v2/persons/${personId}/skills/`, window.location.origin);
	if (highlight) {
		url.searchParams.append("highlight", highlight.toString());
	}

	return fetch(url.toString(), {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
